import { MouseEventHandler, ReactNode } from 'react';
import styles from './Button.module.css';
import { StyleProps } from './types';

type Props = StyleProps & {
	label?: string;
	icon?: ReactNode;
	compact?: boolean;
	frameless?: boolean;
	type?: "submit" | "reset";
	onClick?: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
};

const Button = ({ label, icon, compact, frameless, type, onClick, disabled, className, style }: Props) =>
{
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
	{
		onClick?.(event);
	};

	return (
		<button className={`${styles.button}${frameless ? ` ${styles.frameless}` : ''}${compact ? ` ${styles.compact}` : ''}${label && icon ? ` ${styles.compactRight}` : ''}${className ? ` ${className}` : ''}`} style={style} disabled={disabled} type={type} onClick={handleClick}>{label}{icon}</button>
	);
};

export default Button;
